import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findIndex, isEqual } from 'lodash';
import { Icon } from 'ui';
import filterSuggestions from 'utils/filterSuggestions';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';

class MassAction extends Component {
  constructor(props) {
    super(props);
    this.state = { resources: props.shared };
  }

  componentDidMount() {
    this.props.requestShared();
  }

  componentDidUpdate(prevProps) {
    const { selected, shared } = this.props;
    if (selected.length > 0 && !isEqual(prevProps.selected, selected)) {
      this.props.requestShared();
    }
    if (!isEqual(prevProps.shared, shared)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ resources: shared });
    }
  }

  addResource = resource => {
    this.setState(state => ({
      resources: [...state.resources, resource],
    }));
  };

  removeResource = id => {
    const { resources } = this.state;
    const index = findIndex(resources, { id });

    this.setState({
      resources: [...resources.slice(0, index), ...resources.slice(index + 1)],
    });
  };

  applyChanges = () => {
    if (this.unchanged) return;

    this.props.applyChanges(this.state.resources);
  };

  get unchanged() {
    const resourceIds = this.state.resources
      .map(resource => resource.id)
      .sort();
    const sharedIds = this.props.shared
      .map(sharedResource => sharedResource.id)
      .sort();

    return isEqual(resourceIds, sharedIds);
  }

  get disableApplyButton() {
    return this.unchanged || this.props.applying;
  }

  render() {
    const {
      requestingShared,
      title,
      placeholder,
      noSharedResourceText,
      autocompleteUrl,
      queryParam,
      resource,
    } = this.props;
    const { resources } = this.state;

    return (
      <div>
        <div className="BulkAction-viewHeader">{title}</div>
        <div className="BulkAction-viewContent">
          <RemoteAutoComplete
            placeholder={placeholder}
            className="NewInput NewInput--lightestGray NewInput--tall NewInput--fw mb-16"
            onSuggestionSelected={this.addResource}
            icon="search"
            url={autocompleteUrl}
            mapResponseToSuggestions={response => response[resource]}
            filterSuggestions={filterSuggestions(resources)}
            queryParam={queryParam || 'query'}
          />

          {requestingShared && (
            <div className="quicklist-item d-f jc-c">
              <span className="Spinner mr-4" />
            </div>
          )}

          {!requestingShared &&
            resources.map(({ id, name }) => (
              <div className="quicklist-item" key={id}>
                {name}
                <span
                  className="quicklist-remove"
                  onClick={() => this.removeResource(id)}
                  onKeyDown={e => e.key === 'Enter' && this.removeResource(id)}
                >
                  <Icon
                    name="remove"
                    className="c-brand-gray"
                    tabindex="0"
                    onKeyDown={e =>
                      e.key === 'Enter' && this.removeResource(id)
                    }
                  />
                </span>
              </div>
            ))}

          {!requestingShared && resources.length < 1 && (
            <div className="quicklist-item">{noSharedResourceText}</div>
          )}
        </div>
        <div className="BulkAction-viewButtonContainer">
          <button
            type="button"
            disabled={this.disableApplyButton}
            className={`${
              this.disableApplyButton ? 'NewButton--disabled' : ''
            } NewButton NewButton--fw NewButton--darkNavy NewButton--center NewButton--tall`}
            onClick={this.applyChanges}
          >
            {t('mass_actions.apply')}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  bulk: { selected, inProgress },
  massActions: { shared, requestingShared },
}) => ({
  selected,
  shared,
  requestingShared,
  applying: inProgress,
});

export default connect(mapStateToProps, null)(MassAction);
